import { render } from "./SeriesForm.vue?vue&type=template&id=21107b42"
import script from "./SeriesForm.vue?vue&type=script&lang=js"
export * from "./SeriesForm.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "../i18n/SeriesForm.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fscheduling%2Fcomponents%2FSeriesForm.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__